import { createSelector } from 'redux-bundler'

import config from '~/src/App/config'
import safeStorage from '~/src/Lib/safeStorage'

export default {
  name: 'flags',
  selectAvailableFeatures: createSelector('selectMyFlags', flags => {
    const notProd = config.ENVIRONMENT !== 'production'
    let testFlags = {}
    if (notProd) {
      try {
        const testFlagsJSON = safeStorage().getItem('testFlags')
        if (testFlagsJSON) {
          testFlags = JSON.parse(testFlagsJSON)
        }
      } catch {
        console.warn('Failed to parse testFlags from storage.')
      }
    }
    return new Set(
      Object.entries({
        ...flags,
        ...testFlags,
      })
        .map(([key, value]) => (value ? key : null))
        .filter(Boolean),
    )
  }),
  selectPermittedActions: createSelector('selectCurrentMembership', currentMembership => {
    const effectivePermissions = Array.isArray(currentMembership?.effectivePermissions)
      ? currentMembership.effectivePermissions
      : []
    const permitted = new Set(effectivePermissions)
    if (config.ENVIRONMENT === 'production') return permitted

    let testPermissions = {}
    try {
      const testPermissionsJSON = safeStorage().getItem('testPermissions')
      if (testPermissionsJSON) {
        const parsed = JSON.parse(testPermissionsJSON)
        if (typeof parsed !== 'object' || Array.isArray(parsed)) {
          console.warn('Ignoring testPermissions: expected a JSON object.')
        } else {
          testPermissions = parsed
        }
      }
    } catch {
      console.warn('Failed to parse testPermissions from storage.')
    }
    Object.entries(testPermissions ?? {}).forEach(([key, value]) =>
      value ? permitted.add(key) : permitted.delete(key),
    )
    return permitted
  }),
}
